import { AssetImage } from "@ospweb/sdk-ui";
import { AssetInfoProps } from "./types";

export const AssetInfo = (props: AssetInfoProps) => {
  const { symbol, name, icon } = props;

  return (
    <div className="flex items-center gap-2">
      {icon && icon.trim() !== "" ? (
        <AssetImage
          className="w-6 h-6 flex rounded-full border-border_solid border-[1.25px]"
          width={24}
          height={24}
          src={icon}
          alt={name}
        />
      ) : (
        // 当没有图片时显示一个占位符
        <div className="w-6 h-6 flex items-center justify-center rounded-full border-border_solid border-[1.25px] bg-background_solid_secondary">
          <span className="text-xs text-content_tertiary font-medium">
            {symbol?.charAt(0) || "?"}
          </span>
        </div>
      )}
      <div className="flex flex-col">
        <span className=" body_medium_m text-content_primary">{symbol}</span>
        <span className="body_s text-content_tertiary">{name}</span>
      </div>
    </div>
  );
};
